var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTruckSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 17C28 10.9249 23.0751 6 17 6C10.9249 6 6 10.9249 6 17C6 23.0751 10.9249 28 17 28C23.0751 28 28 23.0751 28 17Z",
    fill: "#201E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0016 5.6001C23.2976 5.6001 28.4016 10.7041 28.4016 17.0001C28.4016 23.2961 23.2976 28.4001 17.0016 28.4001C10.7055 28.4001 5.60156 23.2961 5.60156 17.0001C5.60156 10.7041 10.7055 5.6001 17.0016 5.6001Z",
    stroke: "#D6610D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4512 11H11V20.2988C11 21.3631 11.8391 22.2315 12.8919 22.2785C13.0903 22.9833 13.7377 23.5 14.5061 23.5C15.2738 23.5 15.9207 22.9843 16.1198 22.2805H17.4024V21.3659H16.1198C15.9207 20.6621 15.2738 20.1463 14.5061 20.1463C13.7397 20.1463 13.0937 20.6603 12.8935 21.3623C12.3454 21.3174 11.9146 20.8584 11.9146 20.2988V11.9146H19.5366V19.2317H20.4512V16.4385L21.5455 16.8619C22.1401 17.092 22.5854 17.6406 22.5854 18.1646V22.2805H23.5V18.1182C23.5 17.1989 22.879 16.3811 21.9411 16.0182L20.4512 15.4417V11ZM19.9939 20.1463C19.0678 20.1463 18.3171 20.8971 18.3171 21.8232C18.3171 22.7493 19.0678 23.5 19.9939 23.5C20.92 23.5 21.6707 22.7493 21.6707 21.8232C21.6707 20.8971 20.92 20.1463 19.9939 20.1463ZM13.7439 21.8232C13.7439 21.4022 14.0851 21.061 14.5061 21.061C14.927 21.061 15.2683 21.4022 15.2683 21.8232C15.2683 22.2441 14.927 22.5854 14.5061 22.5854C14.0851 22.5854 13.7439 22.2441 13.7439 21.8232ZM19.2317 21.8232C19.2317 21.4022 19.573 21.061 19.9939 21.061C20.4149 21.061 20.7561 21.4022 20.7561 21.8232C20.7561 22.2441 20.4149 22.5854 19.9939 22.5854C19.573 22.5854 19.2317 22.2441 19.2317 21.8232Z",
    fill: "#D71200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTruckSelected);
export default __webpack_public_path__ + "static/media/redTruckSelected.2d9af83e0bc0729b5a18727ae797e2e6.svg";
export { ForwardRef as ReactComponent };